<div class="card" >
  <div class="icon" [innerHTML]="icon" [ngClass]="'icon-' + colorIcon"></div>
  <div class="card-content">
    <h1>{{ titulo }}</h1>
    <span>{{ subtitulo }}</span>
  </div>
</div>
